export default __webpack_public_path__ + "static/media/kudosIcon.c1ab180f.svg";